import { useEffect } from 'react';
import Button from '../ui/Button.jsx';
import { Card, CardBody, CardFooter, CardHeader } from '../ui/Card.jsx';
import HeadingOne from '../ui/HeadingOne.jsx';

const WriteArticle = ({ heading_img, heading, text, subheading, timer, modal, fn }) => {
    // const [inputValue, setInputValue] = useState('');
    // const [isModalOpen, setIsModalOpen] = useState(false);
    // const timerRef = useRef(null);

    // const TIMER_DURATION = 10;

    // const handleInputChange = (e) => {
    //   setInputValue(e.target.value);

    // if (timerRef.current) clearTimeout(timerRef.current);

    useEffect(() => {
        setTimeout(() => {
            fn.handleAction('modal:set', modal);
        }, timer * 1000);
    });

    // timerRef.current = setTimeout(() => {
    //   setIsModalOpen(true);
    // }, timer * 1000);
    // };

    return (
        <div className="component-email">
            <div className="row">
                <HeadingOne className="w-8/12" image={heading_img} heading={heading} />
            </div>

            <div className="row justify-center">
                <div className="col xl:w-10/12">
                    <Card>
                        <CardHeader heading={subheading} />
                        <CardBody>
                            <div className="row items-center justify-center">
                                <div className="col text-xl">
                                    <div dangerouslySetInnerHTML={{ __html: text }}></div>
                                </div>

                                <div className="col text-xl">
                                    <textarea
                                        rows={4}
                                        className="w-full rounded border p-2"
                                        placeholder="Začni psát..."
                                        // value={inputValue}
                                        // onChange={handleInputChange}
                                    ></textarea>
                                </div>
                            </div>
                        </CardBody>
                        <CardFooter>
                            <Button disabled={true}>Odeslat</Button>
                        </CardFooter>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default WriteArticle;
